// FAQs
document.addEventListener('DOMContentLoaded', function() {
    const faqs = document.querySelectorAll('.faq');
    
    faqs.forEach(faq => {
        const header = faq.querySelector('.faq-header');
        const answer = faq.querySelector('.answer');
        
        header.addEventListener('click', function() {
            const isOpen = faq.classList.contains('active');
            
            if (isOpen) {
                faq.classList.remove('active');
                answer.style.maxHeight = '0';
            } else {
                faqs.forEach(otherFaq => {
                    otherFaq.classList.remove('active');
                    otherFaq.querySelector('.answer').style.maxHeight = '0';
                });
                
                faq.classList.add('active');
                answer.style.maxHeight = answer.scrollHeight + 'px';
            }
        });
    });
});

// Menu
document.addEventListener('DOMContentLoaded', function () {

    // Get the hamburger button and menu
    const hamburger = document.getElementById('hamburger');
    const menu = document.querySelector('.mobile-navigation');
    const overlay = document.querySelector('.mobile-overlay')
    const close = document.querySelector('#close-menu')
    const items = menu.querySelectorAll('.menu-item-has-children');

    // Add click event listener directly to the hamburger button
    hamburger.addEventListener('click', () => {
        menu.classList.toggle('open');
        overlay.classList.toggle('open');
    });

    overlay.addEventListener('click', () => {
        menu.classList.toggle('open');
        overlay.classList.toggle('open');
    });

    close.addEventListener('click', () => {
        menu.classList.toggle('open');
        overlay.classList.toggle('open');
    });

    items.forEach(item => {
        item.addEventListener('click', function (event) {
            if (event.target.tagName === 'A' && event.target.parentElement === this) {
                const isCurrentlyOpen = this.classList.contains('open');
                const subMenu = this.querySelector('.sub-menu');

                // Close all other items
                items.forEach(menuItem => {
                    if (menuItem !== this) {
                        menuItem.classList.remove('open');
                        const otherSubMenu = menuItem.querySelector('.sub-menu');
                        otherSubMenu.style.maxHeight = '0px';
                    }
                });

                // Toggle current item
                if (!isCurrentlyOpen) {
                    this.classList.add('open');
                    // Calculate the actual height needed
                    subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
                } else {
                    this.classList.remove('open');
                    subMenu.style.maxHeight = '0px';
                }

                event.preventDefault();
                event.stopPropagation();
            }
        });
    });

    let resizeTimeout;
    let isMobile = false;

    if (window.innerWidth < 991) {
        isMobile = true;
    }

    window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            console.log('Window width changed to:', window.innerWidth);
            // Your resize handling code here
            if (isMobile && window.innerWidth > 991) {
                isMobile = false;
                menu.classList.remove("open");
                overlay.classList.remove("open");
            }
        }, 250);
    });


    // Language Switchers
    const switchers = Array.from(document.querySelectorAll('.language-switcher'));

    // helper to close all switchers (or optionally skip one)
    const closeAll = (skip = null) => {
        switchers.forEach(s => {
        if (s === skip) return;
        const t = s.querySelector('.lang-dropdown-toggle');
        const m = s.querySelector('.lang-dropdown-menu');
        if (t) t.classList.remove('active'), t.setAttribute('aria-expanded', 'false');
        if (m) m.classList.remove('show'), m.setAttribute('aria-hidden', 'true');
        });
    };

    // initialize each switcher
    switchers.forEach(s => {
        const toggle = s.querySelector('.lang-dropdown-toggle');
        const menu = s.querySelector('.lang-dropdown-menu');

        if (!toggle || !menu) return;

        // toggle open/close for this switcher
        toggle.addEventListener('click', e => {
        e.stopPropagation();
        const isOpen = !toggle.classList.contains('active');

        // close others and open this one
        closeAll(s);

        toggle.classList.toggle('active', isOpen);
        menu.classList.toggle('show', isOpen);

        // accessibility attributes
        toggle.setAttribute('aria-expanded', String(isOpen));
        menu.setAttribute('aria-hidden', String(!isOpen));
        });

        // clicking inside the menu shouldn't bubble to document (optional)
        menu.addEventListener('click', e => {
        e.stopPropagation();
        });

        // close this switcher when selecting a language
        const items = Array.from(menu.querySelectorAll('.lang-dropdown-item'));
        items.forEach(item => {
        item.addEventListener('click', () => {
            toggle.classList.remove('active');
            menu.classList.remove('show');
            toggle.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-hidden', 'true');
        });
        });
    });

    // Click outside: close all
    document.addEventListener('click', e => {
        // if the click is inside any switcher, do nothing
        const insideAny = switchers.some(s => s.contains(e.target));
        if (!insideAny) closeAll();
    });

    // Keyboard: Escape closes all
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') closeAll();
    });

});

window.addEventListener('scroll', () => {
  const nav = document.querySelector('header.site-header');
  if (window.scrollY > 90 && window.innerWidth > 991) {
    nav.classList.add('scrolled');
  } else {
    nav.classList.remove('scrolled');
  }
});

// Cookie Banner + Consent Mode + consent-gated attribution
// The choice lives in localStorage (banner / consent mode) and is mirrored
// into the cookie_consent cookie so PHP can read it: UTM / ad-click
// attribution (inc/attribution.php) and WooCommerce's order attribution only
// run once it's "accepted".
document.addEventListener('DOMContentLoaded', function () {
    var STORAGE_KEY = 'cookie_consent';
    var consent = null;
    try {
        consent = localStorage.getItem(STORAGE_KEY);
    } catch (e) {}

    function getConsentCookie() {
        var match = document.cookie.match(/(?:^|;\s*)cookie_consent=([^;]*)/);
        return match ? match[1] : null;
    }

    // Shared with the mirror subdomains (start.kudofunded.com...), same as
    // the attribution cookie.
    function setConsentCookie(value) {
        var domain = /(^|\.)kudofunded\.com$/.test(location.hostname) ? '; domain=.kudofunded.com' : '';
        var secure = location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = 'cookie_consent=' + value + '; max-age=' + (365 * 24 * 60 * 60) + '; path=/' + domain + '; SameSite=Lax' + secure;
    }

    // Tells the server about the choice. On accept it records this page's URL
    // and referrer — usually the ad landing page, which couldn't be stored
    // before consent. On decline it deletes the (HttpOnly) attribution cookie.
    function sendConsent() {
        if (!window.kudoAttribution) return;
        var body = new URLSearchParams({
            action: 'kudo_attribution_consent',
            url: location.href,
            referrer: document.referrer
        });
        fetch(kudoAttribution.ajaxUrl, { method: 'POST', body: body, credentials: 'same-origin', keepalive: true })
            .catch(function () {});
    }

    // This page was rendered with WooCommerce's tracking set by the old
    // consent state — switch it now (on: starts sourcebuster on this page;
    // off: deletes its cookies).
    function setWooTracking(allow) {
        if (window.wc_order_attribution && typeof window.wc_order_attribution.setOrderTracking === 'function') {
            window.wc_order_attribution.setOrderTracking(allow);
        }
    }

    function applyChoice(value) {
        setConsentCookie(value);
        setWooTracking(value === 'accepted');
        sendConsent();
    }

    // Visitors who chose before the cookie existed (or whose cookie expired):
    // sync it from localStorage once.
    if (consent && getConsentCookie() !== consent) {
        applyChoice(consent);
    }

    var banner = document.getElementById('cookie-banner');
    if (!banner) return;

    // Don't show if the user already made a choice
    if (consent) return;

    // Slight delay so the page settles before sliding up
    setTimeout(function () {
        banner.classList.add('is-visible');
    }, 600);

    document.getElementById('cookie-accept').addEventListener('click', function () {
        localStorage.setItem(STORAGE_KEY, 'accepted');

        if (typeof gtag === 'function') {
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'analytics_storage': 'granted'
            });
        }

        applyChoice('accepted');
        hideBanner();
    });

    document.getElementById('cookie-decline').addEventListener('click', function () {
        localStorage.setItem(STORAGE_KEY, 'declined');
        applyChoice('declined');
        hideBanner();
    });

    function hideBanner() {
        banner.classList.remove('is-visible');
    }
});